/**
 * Created by Christof Sander on 15.07.2016.
 */

var StackTrace  = require('stacktrace-js');
const utils     = require('../lib/utils');
var appConfig   = require('../lib/config').getConfig();

/**
 * this is the global client error handler
 *
 */
var errorHandler = {

	/**
	 * initialize the base data of the error according to the given event and prepare it for the promise chain of error handling.
	 *
	 * @param   event       dom-error-event
	 * @param   tellUser    boolean - tell the user about the error (default: true)
	 * @returns Promise
	 */
	initError: function(event, tellUser){
		var error = {
			message: event.message,
			filename: event.filename || '',
			lineno: event.lineno || -1,
			colno: event.colno || -1,
			stack: (event.error || {}).stack || '',
			error: event.error || {},
			tellUser: tellUser
		};

		return utils.promise.resolve(error);
	},

	/**
	 * sanitize the given error as far as possible (enrich stack)
	 *
	 * @param   error       {} - contains error properties
	 * @returns Promise
	 */
	sanitizeError: function(error){
		return errorHandler.getStack(error);
	},

	/**
	 * submit the error to the server
	 *
	 * @param   error       {} - contains error properties
	 * @param   tellUser    boolean - tell the user about the error (default: true)
	 * @returns Promise
	 */
	submitError: function(error, tellUser){
		return $.ajax({
			contentType:        "application/json; charset=utf-8",
			dataType:"json",
			headers: {
				Accept:         "application/json; charset=utf-8"
			},
			url: '/error',
			method: 'POST',
			data: JSON.stringify(error)
		});
	},

	/**
	 * react to the servers error handling strategy
	 *
	 * @param   errorStrategy       {} - contains the servers strategy
	 * @param   tellUser            boolean - tell the user about the error (default: true)
	 */
	reactToError: function(errorStrategy, tellUser){
		try {
			// TODO: check what todo according to errorStrategy (which is an error object at the moment)
			if(appConfig.error.handleClientError && typeof(componentTree) !== 'undefined' && componentTree.lookup && utils.collectionSize(componentTree.lookup) > 0){
				var errorHandlerComponent;
				if(componentTree.lookup.errorParent)    errorHandlerComponent = componentTree.lookup.errorParent;
				else                                    errorHandlerComponent = componentTree.lookup[Object.keys(componentTree.lookup)[0]];

				if(errorHandlerComponent && utils.isFunction(errorHandlerComponent._handleError) && tellUser !== false){

					console.error(errorStrategy);

					return errorHandlerComponent._handleError({
						component: errorHandlerComponent,
						error: {
							statusCode: 'clientError',
							name: 'clientError',
							errorCode: 'REAL_CLIENT_ERROR',
							message: errorStrategy.message,
							detail: errorStrategy.stack
						}
					});
				}
			}

			console.error(errorStrategy);
		} catch(error){
			// NOTE: errors within this error handling function must not be thrown to prevent infinite error handling loops.
			console.error(error);
		}
	},

	/**
	 * enriches the error by the StackTraceJS-Stack.
	 *
	 * @param   error       {} - contains error properties
	 * @returns Promise
	 */
	getStack: function(error){
		return StackTrace.fromError(error).then(function(trace){
			if(!!trace) {
				// replace original error stack of browser
				error.stack = '';

				// estimate longest functionName
				var maxFunctionNameLength = 0;
				for (var index in trace) {
					maxFunctionNameLength = Math.max(maxFunctionNameLength, trace[index].functionName ? trace[index].functionName.length : 0);
				}

				// prepare left padding of function names
				var pad = '';
				for (var padIndex = 0; padIndex < (maxFunctionNameLength + 3); padIndex++){
					pad += ' ';
				}

				// build stack
				for (var index in trace) {
					error.stack +=
						(pad + trace[index].functionName).slice(-pad.length) + ' @ ' +
						trace[index].fileName + ':' +
						trace[index].lineNumber + ':' +
						trace[index].columnNumber +
						'\n'
					;
				}
			}
			return error;
		});
	},

	/**
	 * this function is used to perform an error
	 *
	 * @param event     Event
	 * @param tellUser  boolean - tell the user about the error (default: true)
	 */
	performError: function(event, tellUser){
		try {
			errorHandler.initError(event, tellUser).then(function(error){
				// errorHandler.sanitizeError(error).then(function(error){
				errorHandler.submitError(error, tellUser).then(function(errorStrategy){
					errorHandler.reactToError(errorStrategy, tellUser);
				});
				// });
			});
		} catch(error){
			console.error(event.error);
			console.log('ERROR DURING ERROR HANDLING', error);
		}
	}
};

window.addEventListener('error', function (event) {
	errorHandler.performError(event);
});

module.exports = {
	performError: errorHandler.performError
};